import { render, staticRenderFns } from "./CompensationProvider.vue?vue&type=template&id=0d6d00b9&"
import script from "./CompensationProvider.vue?vue&type=script&lang=js&"
export * from "./CompensationProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports